import { EndHandler } from 'react-transition-group/Transition';

/**
 * A custom transition end trigger for `react-transition-group`.
 *
 * The `<Transition />` component from `react-transition-group` uses either one
 * of two props - `timeout` or `addEndListener`- to know when to transition from
 * one status to another. The latter one allows more precise control and is
 * decoupled from CSS's actual transition duration.
 *
 * This function triggers when the actual CSS transition of the animated element
 * ends.
 *
 * It also handles a particular case when the element is hidden (thus the
 * CSS transition never happens) to immediately switch the status.
 */
export const handleTransitionEnd: EndHandler<undefined> = (node, done) => {
  if (isVisible(node)) {
    // The node is visible - wait for the CSS transition to end before switching
    // to the next status:
    node.addEventListener('transitionend', done, false);
  } else {
    // The node is hidden, so no transition would occur - switch to the next
    // status immediately:
    done();
  }
};

/*
 * Based on:
 * https://github.com/jquery/jquery/blob/main/src/css/hiddenVisibleSelectors.js
 */
function isVisible(node: HTMLElement) {
  return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length);
}
